import { features } from "@/mocks/home";

export default function HomeFeatures() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-primary-50 text-primary-600 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            全方位守护你的社区体验
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            爱情岛论坛致力于为每一位用户提供安全、舒适、高质量的交流环境
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 rounded-xl p-6 md:p-7 group hover:bg-background-50 transition-colors duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-5 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${feat.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2.5">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}